import React from 'react';
import Select from 'react-select';
import { Controller } from 'react-hook-form';

const InputSelect = ({
  label,
  name,
  control,
  options,
  error,
  required = true,
  placeholder = 'Pilih...'
}) => {
  return (
    <div className="flex flex-col mx-auto justify-center items-center w-full">
      <label className="text-black w-full text-left">
        {label}{required && <span className='text-red-500'> *</span>}
      </label>

      <Controller
        name={name}
        control={control}
        rules={{ required: required }}
        render={({ field }) => (
          <Select
            {...field}
            options={options}
            placeholder={placeholder}
            className="w-full"
            classNamePrefix="react-select"
            value={options.find(option => option.value === field.value) || null}
            onChange={(selectedOption) => field.onChange(selectedOption?.value)}
          />
        )}
      />

      {error && (
        <span className="text-red-500 text-sm text-left w-full">
          {label} harus diisi
        </span>
      )}
    </div>
  );
};

export default InputSelect;
